<template>
  <div class="page_modifiers">
    <h1>Slevy &amp; přirážky</h1>
    <div class="actions">
      <button @click="add" class="add" title="Nová položka">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <tabloid name="page_modifiers" :columns="columns" :data="priceModifiers">
      <template v-slot:outpostId="{ row }">
        <inputerSelect
          name="Hlídka"
          :paths="['priceModifiers', row.id, 'outpostId']"
          :items="outposts"
          :getKey="item => item.id">
          <template v-slot:default="props">{{ props.item != null ? `${props.item.id}. PH - ${props.item.city}` : "Vyberte hlídku" }}</template>
          <template v-slot:item="props">{{ props.item.id }}. PH - {{ props.item.city }}</template>
        </inputerSelect>
      </template>
      <template v-slot:message="{ row }">
        <inputer name="Poznámka" :paths="['priceModifiers', row.id, 'message']" />
      </template>
      <template v-slot:amount="{ row }">
        <inputerNumber name="Množství" :paths="['priceModifiers', row.id, 'amount']" />
      </template>
      <template v-slot:createdAt="{ value }">
        {{ value | cz_datetime }}
      </template>
      <template v-slot:actions="{ row }">
        <button @click="remove(row)" class="remove" title="Odstranit položku">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import tabloid from "../../components/tabloid.vue";
import inputer from "../../components/inputer";
import inputerNumber from "../../components/inputer-number";
import inputerSelect from "../../components/inputer-select";
import { data } from "../../store_utils";

export default {
  name: "priceModifiers",
  components: {
    tabloid,
    inputer,
    inputerNumber,
    inputerSelect
  },
  data: () => ({
    columns: {
      outpostId: { title: "Hlídka" },
      message: { title: "Poznámka" },
      amount: { title: "Částka" },
      createdAt: { title: "Čas" },
      actions: { title: " " },
    }
  }),
  computed: {
    ...mapState(["priceModifiers", "outposts"])
  },
  methods: {
    add() {
      const id = data.newGuid();
      this.$store.commit("add", {
        paths: ["priceModifiers", id],
        value: { id: id, createdAt: new Date() }
      });
    },
    remove(modifier) {
      if (!confirm("Opravdu chcete odstranit tuto položku?")) return;

      this.$store.commit("remove", {
        paths: ["priceModifiers", modifier.id]
      });
    }
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_modifiers
  @include table-view()
  grid-template-areas: "label add" "table table"
  grid-template-columns: auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: label
  .add
    grid-area: add
  table
    grid-area: table
    .remove
      @include button-danger()
</style>